export enum placeUrls {
    ownedVehicles = "place/owned-vehicles",
    ferryOrdersParkings = "reports/depo-summary/ferry-orders",
    nonFerryOrdersParkings = "reports/depo-summary/non-ferry-orders",
    entryOrExit = "place/entry-exit"
}

export enum lightboardUrls {
    lightBoard = "lightboard",
    allLightBoards = "lightboard/all",
    sings = "lightboard/message/signs"
}